import { useReducedMotion } from 'framer-motion';

/**
 * Motion rule R4: `prefers-reduced-motion` disables animation entirely while
 * every state stays fully readable. Components must branch on this hook
 * before animating (framer-motion springs ignore CSS-level kill switches).
 *
 * @returns `true` when it is safe to animate.
 */
export function useMotionSafe(): boolean {
  return !useReducedMotion();
}
